import { HugeiconsIcon } from "@hugeicons/react";
import { LoaderCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import type * as React from "react";

import { cn } from "../utils/index";

// Literals before the spread, not destructuring defaults: a default fires on
// `undefined`, so role={undefined} could not opt out.
function Spinner({
  className,
  ...props
}: Omit<React.ComponentProps<typeof HugeiconsIcon>, "icon">) {
  return (
    <HugeiconsIcon
      icon={LoaderCircleIcon}
      role="status"
      aria-label="Loading"
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  );
}

export { Spinner };
